namespace Matrix.Dashboards {

    export interface BsPagerOptions {
        page: number;
        total: number;
        maxVisible?: number;
        first?: string;
        last?: string;
        next?: string;
        prev?: string;
        wrapClass?: string;
        paginationClass?: string;
        activeClass?: string;
        disabledClass?: string;
        nextClass?: string;
        prevClass?: string;
        lastClass?: string;
        firstClass?: string;
    }

    export function bsPagerMarkup(opt: BsPagerOptions) {

        opt = Q.extend({
            total: 0,
            page: 1,
            maxVisible: null,
            next: '<i class="fa fa-caret-right"></i>',
            prev: '<i class="fa fa-caret-left"></i>',
            first: '<span aria-hidden="true">&larr;</span>',
            last: '<span aria-hidden="true">&rarr;</span>',
            wrapClass: 'bs-pager',
            paginationClass: 'pagination pagination-xs',
            activeClass: 'active',
            disabledClass: 'disabled',
            nextClass: 'next',
            prevClass: 'prev',
            lastClass: 'last',
            firstClass: 'first'
        }, opt);

        if (opt.total <= 0)
            return "";

        if (!opt.maxVisible)
            opt.maxVisible = opt.total;

        var sb = ['<nav class="', Q.attrEncode(opt.wrapClass), '"><ul class="', Q.attrEncode(opt.paginationClass), '">'];

        if (opt.first != null && opt.page > 1) {
            sb.push('<li data-lp="1" class="page-item ');
            sb.push(Q.attrEncode(opt.firstClass));
            sb.push('"><a class="page-link" href="javascript:;">');
            sb.push(opt.first);
            sb.push('</a></li>');
        }

        if (opt.prev != null) {
            sb.push('<li data-lp="');
            sb.push(Math.max(opt.page - 1, 1).toString());
            sb.push('" class="page-item ');
            sb.push(Q.attrEncode(opt.prevClass));
            sb.push('"><a class="page-link');
            if (opt.page <= 1)
                sb.push(' disabled');
            sb.push('" href="javascript:;">');
            sb.push(opt.prev);
            sb.push('</a></li>');
        }

        var left, right, half: number;
        half = Math.max(Math.floor(opt.maxVisible / 2), 1);
        left = Math.max(opt.page - half, 1);
        right = Math.min(opt.page + half, opt.total);
        while (right - left + 1 < opt.maxVisible) {
            if (left > 1)
                left--;
            else if (right < opt.total)
                right++;
            else
                break;
        }
        while (right - left + 1 > opt.maxVisible) {
            if (right > opt.page)
                right--;
            else if (left < opt.page)
                left++;
            else
                break;
        }

        for (var c = left; c <= right; c++) {
            sb.push('<li data-lp="');
            sb.push(c.toString());
            sb.push('" class="page-item');
            if (c == opt.page && opt.maxVisible > 1)
                sb.push(' active');
            sb.push('"><a class="page-link" href="javascript:;">');
            if (opt.maxVisible == 1)
                sb.push('Page ');
            sb.push(Q.htmlEncode(c));
            sb.push('</a></li>');
        }

        if (opt.next != null) {
            sb.push('<li data-lp="');
            sb.push(Math.min(opt.page + 1, opt.total).toString());
            sb.push('" class="page-item ');
            sb.push(Q.attrEncode(opt.nextClass));
            sb.push('"><a class="page-link');
            if (opt.page >= opt.total)
                sb.push(' disabled');
            sb.push('" href="javascript:;">');
            sb.push(opt.next);
            sb.push('</a></li>');
        }

        if (opt.last != null && opt.page < opt.total) {
            sb.push('<li data-lp="');
            sb.push(opt.total.toString());
            sb.push(' class="page-item ');
            sb.push(Q.attrEncode(opt.lastClass));
            sb.push('"><a class="page-link" href="javascript:;">');
            sb.push(opt.last);
            sb.push('</a></li>');
        }
        sb.push('</ul></nav>');
        return sb.join('');
    }
}